<template>
  <div class="container-fluid">
    <div
      class="mt-4 page-header min-height-300 border-radius-xl"
      :style="{
        backgroundImage:
          'url(' + require('@/assets/img/curved-images/curved14.jpg') + ')',
        backgroundPositionY: '50%',
      }"
    >
      <span class="mask bg-gradient-success opacity-6"></span>
    </div>
    <div class="mx-4 overflow-hidden card card-body blur shadow-blur mt-n6">
      <div class="row gx-4">
        <div class="col-auto">
          <div class="avatar avatar-xl position-relative">
            <img
              src="@/assets/img/purepay-logo.png"
              alt="profile_image"
              class="shadow-sm w-100 border-radius-lg"
            />
          </div>
        </div>
        <div class="col-auto my-auto">
          <div class="h-100">
            <h5 class="mb-1">金付宝-管理后台</h5>
            <p class="mb-0 text-sm font-weight-bold">感谢选择金付宝，我们将努力提供最快捷最稳定最可靠的智能物联网解决方案</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12">
        <div class="mb-4 card">
          <div class="p-3 pb-0 card-header">
            <h6 class="mb-1 title-main">笃定-智行</h6>
            <p class="text-sm subtitle">选择专业  选择专注  选择长久</p>
          </div>
          <div class="p-3 card-body">
            <div class="row">
              <default-project-card
                title="笃定未来"
                :image="img1"
                label="专业的素养"
                description="随着互联网、人工智能、大数据的持续进化，我们已经看得到更美好，
                更有挑战性的未来，想了解我们能帮您什么吗？"
                :authors="[
                  {
                    image: team1,
                    name: 'Elena Morison',
                  },
                  {
                    image: team2,
                    name: 'Ryan Milly',
                  },
                  {
                    image: team3,
                    name: 'Nick Daniel',
                  },
                  {
                    image: team4,
                    name: 'Peterson',
                  },
                ]"
                :action="{
                  color: 'success',
                  label: '跟我们聊聊',
                  onClick: () => this.showQRCodeDialog(),
                }"
              />

              <default-project-card
                title="智能升级"
                :image="img2"
                label="专注于目标"
                description="我们持续关注于智能化在硬件设备上的规模化应用，以最符合用户期望
                的方式融入日常的生活中，体会更智能美好的未来"
                :authors="[
                  {
                    image: team3,
                    name: 'Nick Daniel',
                  },
                  {
                    image: team4,
                    name: 'Peterson',
                  },
                  {
                    image: team1,
                    name: 'Elena Morison',
                  },
                  {
                    image: team2,
                    name: 'Ryan Milly',
                  },
                ]"
                :action="{
                  color: 'success',
                  label: '跟我们聊聊',
                  onClick: () => this.showQRCodeDialog(),
                }"
              />

              <default-project-card
                title="行者致远"
                :image="img3"
                label="持之以恒的投入"
                description="设备的进化是无止境的，为了迎接更多业务规模和业务模式的
                挑战，我们一直在持续努力，唯如此方能达至目标"
                :authors="[
                  {
                    image: team4,
                    name: 'Peterson',
                  },
                  {
                    image: team3,
                    name: 'Nick Daniel',
                  },
                  {
                    image: team1,
                    name: 'Elena Morison',
                  },
                  {
                    image: team2,
                    name: 'Ryan Milly',
                  },
                ]"
                :action="{
                  color: 'success',
                  label: '跟我们聊聊',
                   onClick: () => this.showQRCodeDialog(),
                }"
              />

              <div class="mb-4 col-xl-3 col-md-6 mb-xl-0">
                <place-holder-card
                  :title="{ text: '更多能力进化中', variant: 'h5' }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

    <div v-if="showQRCode" class="modal fade show d-block" tabindex="-1" style="display: block; z-index: 1050;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">联系我们</h5>
          </div>
          <div class="modal-body">
            <img :src="qrCodeImage" alt="二维码" class="img-fluid" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeQRCodeDialog">关闭</button>
          </div>
        </div>
      </div>
    </div>
  
</template>

<script>
import sophie from "@/assets/img/kal-visuals-square.jpg";
import marie from "@/assets/img/marie.jpg";
import ivana from "@/assets/img/ivana-square.jpg";
import peterson from "@/assets/img/team-4.jpg";
import nick from "@/assets/img/team-3.jpg";
import img1 from "@/assets/img/home-decor-1.jpg";
import img2 from "@/assets/img/home-decor-2.jpg";
import img3 from "@/assets/img/home-decor-3.jpg";
import team1 from "@/assets/img/team-1.jpg";
import team2 from "@/assets/img/team-2.jpg";
import team3 from "@/assets/img/team-3.jpg";
import team4 from "@/assets/img/team-4.jpg";
import {
  faFacebook,
  faTwitter,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import DefaultProjectCard from "../components/DefaultProjectCard.vue";
import PlaceHolderCard from "@/examples/Cards/PlaceHolderCard.vue";
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import QRCode from 'qrcode';

export default {
  name: "ProfileOverview",
  components: {
    //SoftSwitch,
    //ProfileInfoCard,
    //SoftAvatar,
    DefaultProjectCard,
    PlaceHolderCard,
  },
  data() {
    return {
      showMenu: false,
      sophie,
      marie,
      ivana,
      peterson,
      nick,
      img1,
      team1,
      team2,
      team3,
      team4,
      img2,
      img3,
      faFacebook,
      faTwitter,
      faInstagram,
      showQRCode: false, // 控制二维码弹窗的显示与隐藏
      qrCodeImage: '', // 二维码图片链接，可以替换成你的二维码链接
    };
  },

  mounted() {
    this.$store.state.isAbsolute = true;
    setNavPills();
    setTooltip(this.$store.state.bootstrap);
    
  },
  methods: {

    showQRCodeDialog() {
      // 显示二维码对话框
      const qrData = "358502asdfasdfasdfsdf56"; // 二维码的内容
      QRCode.toDataURL(qrData, { errorCorrectionLevel: 'H' })
        .then((url) => {
          this.qrCodeImage = url; // 生成的二维码图片的URL
          this.isQRCodeVisible = true; // 显示二维码弹框
        })
        .catch((err) => {
          console.error("二维码生成失败", err);
        });
      this.showQRCode = true;
    },
    closeQRCodeDialog() {
      // 关闭二维码对话框
      this.showQRCode = false;
    },
  },

  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
};
</script>

<style scoped>
/* 主标题样式 */
.title-main {
  font-size: 1.75rem; /* 增大字体 */
  font-weight: bold;  /* 加粗 */
  color: #2c3e50;  /* 深色字体 */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
  letter-spacing: 1px; /* 适当增大字母间距 */
  line-height: 1.5; /* 增加行高，让文本显得更加舒适 */
}

/* 副标题样式 */
.subtitle {
  font-size: 1.125rem; /* 稍微小一点的字体 */
  color: #7f8c8d; /* 使用较浅的颜色 */
  line-height: 1.6; /* 适当的行间距 */
  margin-top: 0.5rem; /* 增加和主标题之间的距离 */
}

/* modal 样式 */
.modal {
  display: block; /* 保证 modal 显示 */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明背景 */
  z-index: 1050;
}

.modal-dialog {
  max-width: 500px;
  margin: auto;
}

.modal-body img {
  max-width: 100%;
  height: auto;
}
</style>
